import React from "react";
import BasicModalOrder from "../../Layout/BasicModalOrder";
import moment from "moment";
import styled from "styled-components";
import TextInputModal from "../../common/TextInputModal";
import { Input } from "antd";
const { TextArea } = Input;
import EditAdditional from "./EditAdditional";
import { RiArrowGoBackLine } from "react-icons/ri";
import Axios from "axios";
import EmailBlockEach from "../../common/GlobalModals/Orders/editModal/AdditionalServices/EmailBlockEach";
import { Button2, Button1, LongButton, MainBlock } from "../../common/Buttons";
import {
  meanings_options,
  warrantly_option,
} from "../../../helpers/GlobalOptions";
import { IconExclamation, IconRestore } from "../../Layout/Icons";
import { Tooltip, Modal } from "antd";
const { confirm } = Modal;

class ListOfDocumentsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_items: [],
      created_at: "",
      customer: "",
      email: "",
      document_plan: {
        asset: {},
        document_type: {},
      },
      end_date: null,
      id: 0,
      invoice_number: "",
      number: "",
      order: {},
      order_id: 0,
      phone: "",
      price: 0,
      start_date: null,
      total: 0,
      updated_at: "",
      warranty: null,
      editmodal: false,
      created_at: null,
      canceled: false,
      editDetails: {
        contract_items: [],
      },
      contract_emails: [],
      contact_form: {
        sender: "",
        subject: "",
        text: "",
      },
      accepted_rules: false,
      sendMail: false,
      preview_document: true,
      preview_information: true,
      preview_mail: true,
    };
  }

  getNum = (val) => {
    val = +val || 0;
    return val.toFixed(2);
  };
  frompercentage = (partialValue, totalValue) => {
    return ((100 * partialValue) / totalValue).toFixed(2);
  };
  topercentage = (percent, total) => {
    return ((percent / 100) * total).toFixed(2);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.objectData).length > 0) {
      let item = nextProps.objectData;
      let contractItemsArray = [];
      if (item.contract_items !== undefined) {
        item.contract_items.forEach((item) => {
          contractItemsArray.push({
            ...item,
            item_pricePerc: this.frompercentage(
              item.item_price,
              item.product_price
            ),
          });
        });
      }
      this.setState({
        ...item,
        preview_document: true,
        editDetails: {
          id: item.id,
          order_id: item.order_id,
          order_id2: item.hasOwnProperty("order") ? item.order.id_order : "",
          document_plan_id: item.document_plan_id,
          document_type_id: item.document_type_id,
          phone: item.phone || "+370",
          buy_date: item.buy_date ? moment(item.buy_date) : moment(),
          customer: item.customer || "",
          email: item.email || "",
          number: item.number || 0,
          invoice_number: item.invoice_number || "",
          warranty: +item.warranty || undefined,
          charge: item.charge || 0,
          price: item.price || 0,
          total: item.total || 0,
          contract_items: contractItemsArray,
          editable: item.editable,
        },
      });
    }
    if (nextProps.objectData.id !== this.state.id) {
      const textariaText = `Gerb. Kliente,

  Sveikiname, įsigijus pratęsto garantinio aptarnavimo sertifikatą (PPG).
  Prašome iššsaugoti šį sertifikatą.`;
      let subjectText;
      if (nextProps.objectData.store_id == null) {
        subjectText = `Užsakymas #${nextProps.objectData.invoice_number}. Sertifikatas ${nextProps.objectData.number}`;
      } else {
        subjectText = `Sertifikatas ${nextProps.objectData.number}`;
      }
      if (this.props.createdNew) {
        this.setState(
          {
            editmodal: true,
            contact_form: {
              sender: nextProps.objectData.email || "",
              subject: subjectText,
              text: textariaText,
            },
          },
          () => this.props.stopCreateNew()
        );
      } else {
        this.setState({
          editmodal: false,
          contact_form: {
            sender: nextProps.objectData.email || "",
            subject: subjectText,
            text: textariaText,
          },
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.editDetails.price !== prevState.editDetails.price) {
      this.setTotalPrice();
    }
  }

  handleSave = () => {};

  onChangeContactForm = (e) => {
    this.setState({
      contact_form: {
        ...this.state.contact_form,
        [e.target.name]: e.target.value,
      },
    });
  };

  warrantlyOption = (key) => {
    const findWarrantly = warrantly_option.find((find) => find.value == key);
    return findWarrantly ? findWarrantly.label : "There is no guarantee";
  };

  additionalOption = (key) => {
    const findAdditional = meanings_options.find((find) => find.value == key);
    return findAdditional ? findAdditional.label : "Other...";
  };

  startEdit = () => {
    this.setState({
      editmodal: !this.state.editmodal,
    });
  };

  onChangeContract = (e, select) => {
    // const editDetailsObj = { ...editDetails };
    if (select === "document_type_id") {
      this.setState({
        editDetails: {
          ...this.state.editDetails,
          document_type_id: e,
          document_plan_id: undefined,
        },
      });
    } else if (select) {
      this.setState({
        editDetails: {
          ...this.state.editDetails,
          [select]: e,
        },
      });
    } else if (e.target.name === "price") {
      let editDetailsObj = { ...this.state.editDetails };
      editDetailsObj.price = e.target.value;

      this.setState({
        editDetails: editDetailsObj,
      });
    } else {
      this.setState({
        editDetails: {
          ...this.state.editDetails,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  onChangeContractItem = (e, index) => {
    let editDetailsObj = { ...this.state.editDetails };
    const parentName = e.target.name;
    const parentNumber = +e.target.value || 0;

    if (parentName === "item_price") {
      editDetailsObj.contract_items[index].item_pricePerc = this.frompercentage(
        e.target.value,
        editDetailsObj.contract_items[index].product_price
      );
      editDetailsObj.contract_items[index].item_price = parentNumber;
    } else if (parentName == "item_pricePerc") {
      editDetailsObj.contract_items[index].item_pricePerc = parentNumber;
      editDetailsObj.contract_items[index].item_price = this.topercentage(
        parentNumber,
        editDetailsObj.contract_items[index].product_price
      );
    } else if (parentName == "item_discount") {
      editDetailsObj.contract_items[index].item_discount = parentNumber;
    } else if (parentName == "product_price") {
      editDetailsObj.contract_items[index].product_price = parentNumber;
      editDetailsObj.contract_items[index].item_price = this.topercentage(
        editDetailsObj.contract_items[index].item_pricePerc,
        parentNumber
      );
    } else {
      editDetailsObj.contract_items[index][e.target.name] = e.target.value;
    }

    const itemPrice = this.getNum(
      editDetailsObj.contract_items[index].item_price
    );
    const discount = this.getNum(
      editDetailsObj.contract_items[index].item_discount
    );
    const product_price = this.getNum(
      editDetailsObj.contract_items[index].product_price
    );
    const counter = itemPrice - discount;
    editDetailsObj.contract_items[index].item_total = this.getNum(counter);

    this.setState(
      {
        editDetails: editDetailsObj,
      },
      () => this.setTotalPrice()
    );
  };

  addContractItem = (newObj) => {
    this.setState({
      editDetails: {
        ...this.state.editDetails,
        contract_items: [newObj, ...this.state.editDetails.contract_items],
      },
    });
  };

  addAdditionalItem = (index) => {
    const editDetailsObj = { ...this.state.editDetails };

    const newObj = {
      key: undefined,
      text: "",
    };

    editDetailsObj.contract_items[index].additional_data.push(newObj);
    this.setState({
      editDetails: editDetailsObj,
    });
  };

  changeAdditionalItem = (index, itemIndex, value, input) => {
    const editDetailsObj = { ...this.state.editDetails };

    editDetailsObj.contract_items[index].additional_data[itemIndex][input] =
      value;
    this.setState({
      editDetails: editDetailsObj,
    });
  };

  removeAdditionalItem = (index, itemIndex) => {
    const editDetailsObj = { ...this.state.editDetails };

    editDetailsObj.contract_items[index].additional_data.splice(itemIndex, 1);
    this.setState({
      editDetails: editDetailsObj,
    });
  };

  onSubmitHandler = () => {
    const editDetailsObj = { ...this.state.editDetails };

    const postVariables = {
      contract: {
        document_plan_id: editDetailsObj.document_plan_id,
        number: editDetailsObj.number,
        phone: editDetailsObj.phone,
        customer: editDetailsObj.customer,
        buy_date: editDetailsObj.buy_date,
        email: editDetailsObj.email,
        invoice_number: editDetailsObj.invoice_number,
        warranty: editDetailsObj.warranty,
        price: editDetailsObj.price,
        total: editDetailsObj.total,
      },
    };

    this.props
      .updateContract(
        editDetailsObj.order_id,
        editDetailsObj.id,
        postVariables,
        editDetailsObj.contract_items
      )
      .then((response) => {
        this.setState({
          ...response,
          contact_form: {
            ...this.state.contact_form,
            sender: response.email,
          },
        });
        editDetailsObj.contract_items.forEach((item) => {
          const contractItem = {
            contract_item: {
              // order_row_id: item.order_row_id,
              item_price: isNaN(item.item_price) ? 0 : item.item_price,
              item_discount: item.item_discount,
              item_total: item.item_total,
              product_price: item.product_price,
              category: item.category,
              manufacturer: item.manufacturer,
              model: item.model,
              id_number: item.id_number,
              additional_data: item.additional_data,
            },
          };
          if (item.created_at) {
            this.props
              .updateContractItemTest(
                editDetailsObj.order_id,
                response.id,
                contractItem,
                item.id
              )
              .then((res) => {
                if (res) {
                  const findIndex = editDetailsObj.contract_items.findIndex(
                    (find) => find.id == res.id
                  );
                  if (findIndex !== -1) {
                    editDetailsObj.contract_items[findIndex] = res;
                    let contracits = this.state.contract_items;
                    contracits[findIndex] = res;
                    (contracits[findIndex].item_pricePerc = this.frompercentage(
                      contracits[findIndex].item_price,
                      contracits[findIndex].product_price
                    )),
                      this.setState(
                        {
                          editDetails: editDetailsObj,
                          contract_items: contracits,
                          editmodal: false,
                        },
                        this.props.getDocumentShow(response.id)
                      );
                  }
                }
              });
          } else {
            this.props
              .createContractItemTest(
                editDetailsObj.order_id,
                response.id,
                contractItem
              )
              .then((res) => {
                if (res) {
                  const findIndex = editDetailsObj.contract_items.findIndex(
                    (find) => find.id == item.id
                  );
                  if (findIndex !== -1) {
                    editDetailsObj.contract_items[findIndex] = res;
                    let contracits = this.state.contract_items;
                    contracits[findIndex] = res;
                    contracits[findIndex].item_pricePerc = this.frompercentage(
                      contracits[findIndex].item_price,
                      contracits[findIndex].product_price
                    );
                    this.setState(
                      {
                        editDetails: editDetailsObj,
                        contract_items: contracits,
                        editmodal: false,
                      },
                      this.props.getDocumentShow(response.id)
                    );
                  }
                }
              });
          }
        });
      });
  };

  setContractItems = (items) => {
    const editDetailsObj = { ...this.state.editDetails };
    editDetailsObj.contract_items = items;
    this.setState({
      editDetails: editDetailsObj,
    });
  };

  setTotalPrice = () => {
    const editDetailsObj = { ...this.state.editDetails };
    if (editDetailsObj.contract_items.length > 0) {
      let reducer = editDetailsObj.contract_items.reduce(
        (acc, cur) => acc + Number(cur.item_total == NaN ? 0 : cur.item_total),
        0
      );
      let total = +reducer + +editDetailsObj.price;
      editDetailsObj.total = total;
    } else {
      editDetailsObj.total = editDetailsObj.price;
    }
    this.setState({
      editDetails: editDetailsObj,
    });
  };

  deleteContractItem = (index, created_at, id) => {
    const editDetailsObj = { ...this.state.editDetails };

    if (created_at) {
      this.props
        .deleteContractItem(editDetailsObj.order_id, editDetailsObj.id, id)
        .then((res) => {
          editDetailsObj.contract_items.splice(index, 1);
          this.setState(
            {
              editDetails: editDetailsObj,
            },
            () => this.recalculate()
          );
        });
    } else {
      editDetailsObj.contract_items.splice(index, 1);
      this.setState(
        {
          editDetails: editDetailsObj,
        },
        () => this.recalculate()
      );
    }
  };

  recalculate = () => {
    const editDetailsObj = { ...this.state.editDetails };
    if (editDetailsObj.contract_items.length > 0) {
      let reducer = editDetailsObj.contract_items.reduce(
        (acc, cur) => acc + Number(cur.item_total == NaN ? 0 : cur.item_total),
        0
      );
      let total = +reducer - +editDetailsObj.price;
      editDetailsObj.total = total;
    } else {
      editDetailsObj.total = editDetailsObj.price;
    }
    this.setState(
      {
        editDetails: editDetailsObj,
      },
      () => this.onSubmitHandler()
    );
  };

  downloadDocument = () => {
    Axios({
      url: `/api/v1/contracts/${this.state.id}/download`,
      method: "POST",
      responseType: "blob", // important
      headers: { Accept: "application/vnd.ms-excel" },
    }).then((response) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute(
        "download",
        `${this.state.order_id + "_Contract_" + this.state.id}.pdf`
      ); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  sendEmailMessage = () => {
    const variablesMail = {
      contract_email: {
        receiver_email: this.state.contact_form.sender,
        subject: this.state.contact_form.subject,
        body: this.state.contact_form.text,
      },
    };
    this.props
      .sendContractEmail(0, this.state.id, variablesMail)
      .then((res) => {
        if (res) {
          const editDetailsObj = { ...this.state.editDetails };
          editDetailsObj.editable = true;
          // editDetailsObj.contract_email = [...editDetailsObj.contract_email, res.data]
          let newArray = [...this.state.contract_emails];
          newArray.push(res);
          this.setState({
            editDetails: editDetailsObj,
            contract_emails: newArray,
          });
        }
      });
  };

  checkedPrivilegies = () => {
    if (this.props.auth.role === "store_user") {
      const diff = moment().diff(this.state.created_at, "days");
      return diff < 7;
    } else {
      return true;
    }
  };

  openBlock = (block) => {
    this.setState({
      [block]: !this.state[block],
    });
  };

  blocksRender(action) {
    return (
      <>
        <MainBlock
          color={"#00aaa0"}
          action={this.state.preview_mail}
          onChange={() => this.openBlock("preview_mail")}
        >
          Contact by email
        </MainBlock>
        {this.state.preview_mail && (
          <EmailBlock>
            {this.state.sendMail && (
              <div className="mb-3">
                <div className="info_block"></div>
                <TextInputModal
                  required="true"
                  text="Sender"
                  placeholder="Sender"
                  value="BIGBOX.LT <info@bigbox.lt>"
                  disabled={true}
                />
                <TextInputModal
                  required="true"
                  text="Recipient"
                  placeholder="Recipient"
                  name="sender"
                  // disabled={history}
                  value={this.state.contact_form.sender}
                  onChange={(e) => this.onChangeContactForm(e)}
                />
                <TextInputModal
                  required="true"
                  text="Subject"
                  placeholder="Subject"
                  name="subject"
                  // disabled={history}
                  value={this.state.contact_form.subject}
                  onChange={(e) => this.onChangeContactForm(e)}
                />
                <div className="text-bold my-1">
                  Message <span className="orange_color">*</span>
                </div>
                <TextArea
                  placeholder="Message"
                  name="text"
                  // disabled={history}
                  value={this.state.contact_form.text}
                  onChange={(e) => this.onChangeContactForm(e)}
                  rows={4}
                />
                <div className="d-flex justify-content-center my-2">
                  <Button2
                    text={"Send"}
                    onClick={() => this.sendEmailMessage()}
                  />
                </div>
              </div>
            )}
            {this.state.contract_emails.map((item, index) => (
              <EmailBlockEach key={index} item={item} />
            ))}
            <br />
            <div style={{ position: "relative" }}>
              <Button1
                style={{
                  position: "absolute",
                  top: "-16px",
                  left: "50%",
                  transform: "translate(-50%, 0px)",
                }}
                text={this.state.sendMail ? "Shrink" : "Send a letter"}
                option={this.state.sendMail ? "minus" : "plus"}
                onClick={() => this.openBlock("sendMail")}
              />
              <hr />
            </div>
          </EmailBlock>
        )}
      </>
    );
    return emailBlock;
  }

  cancelDocument = (type) => {
    if (type == "uncancel") {
      return this.props.cancelDocument(this.state.id, "").then((response) =>
        this.setState({
          ...response,
        })
      );
    }
    let promtCancelDocument = prompt(
      `The reason you want to cancel the document ${this.state.number} ?`,
      ""
    );

    if (promtCancelDocument) {
      this.props
        .cancelDocument(this.state.id, promtCancelDocument)
        .then((response) =>
          this.setState({
            ...response,
          })
        );
    }
  };

  render() {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Document <span className="text-orange">#</span>
        {this.state.number}
        {this.state.canceled_at && (
          <span className="ml-2 text-danger">Canceled</span>
        )}
      </span>
    );
    return (
      <BasicModalOrder
        handleSave={() => this.handleSave()}
        status="documentModal"
        text={tilteSpan}
        // text={`Dokumentas #${this.state.number}`}
      >
        <div className="row">
          <div className="col">
            <MainBlock
              color={"#ffa800"}
              action={this.state.preview_document}
              onChange={() => this.openBlock("preview_document")}
            >
              Dokumentas
            </MainBlock>
            {this.state.preview_document && (
              <>
                {this.state.editmodal ? (
                  <div>
                    <div className="my-2" style={{ fontSize: "13px" }}>
                      <div className="border">
                        <div
                          style={{
                            backgroundColor: "#f7f7f7",
                            width: "100%",
                            height: "38px",
                            padding: " 0 10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              color: "black",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {this.state.customer}
                            </span>
                            {this.checkedPrivilegies() && (
                              <button
                                className="btn btm-sm color-orange"
                                onClick={() => this.startEdit()}
                              >
                                <RiArrowGoBackLine color="orange" />
                              </button>
                            )}
                          </span>
                        </div>
                        <EditAdditional
                          data={this.state.editDetails}
                          getNum={this.getNum}
                          documentPlan={this.props.documentPlan}
                          documentType={this.props.documentType}
                          addContractItem={this.addContractItem}
                          onChangeContract={this.onChangeContract}
                          onChangeContractItem={this.onChangeContractItem}
                          addAdditionalItem={this.addAdditionalItem}
                          changeAdditionalItem={this.changeAdditionalItem}
                          removeAdditionalItem={this.removeAdditionalItem}
                          setContractItems={this.setContractItems}
                          topercentage={this.topercentage}
                          deleteContractItem={this.deleteContractItem}
                          contract_emails={this.state.contract_emails}
                          sendContractEmail={this.sendContractEmail}
                          onSubmitHandler={this.onSubmitHandler}
                          setTotalPrice={this.setTotalPrice}
                          auth={this.props.auth}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="col-12 mb-3"
                    style={{ backgroundColor: "#fbfbfb" }}
                  >
                    <div className="d-flex justify-content-between mb-2">
                      <div
                        style={{
                          fontSize: "19px",
                          fontWeight: "700",
                        }}
                      >
                        {" "}
                        {this.state.customer}
                      </div>
                      {!this.state.canceled_at && (
                        <div className="d-flex">
                          {this.checkedPrivilegies() && (
                            <Button1
                              style={{ marginLeft: "5px" }}
                              text={"Edit"}
                              option={"edit"}
                              onClick={() => this.startEdit()}
                            />
                          )}

                          {["admin", "accounting"].includes(this.props.auth.role) && (
                            <Button1
                              style={{ marginLeft: "5px" }}
                              text={"Cancel"}
                              option={"times"}
                              onClick={() => this.cancelDocument()}
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {this.state.reason && (
                      <div className="text-danger font-weight-bold d-flex justify-content-between">
                        <div>{this.state.reason}</div>
                        <div>
                          <Tooltip placement="top" title="Uncancel">
                            <IconRestore
                              className="text-base text-primary"
                              onClick={() =>
                                confirm({
                                  title: "Are you sure?",
                                  icon: (
                                    <IconExclamation className="text-primary" />
                                  ),
                                  content:
                                    "You will not be able to undo this action",
                                  onOk: () => {
                                    this.cancelDocument("uncancel");
                                    console.log("OK");
                                  },
                                  onCancel() {
                                    console.log("Cancel");
                                  },
                                })
                              }
                            />
                          </Tooltip>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-6 my-3">
                        {this.state.buy_date && (
                          <UlElements>
                            <li className="font-weight-bold">
                              Date of purchase
                            </li>
                            <li className="li-font">
                              {moment(this.state.buy_date).format("YYYY-MM-DD")}
                            </li>
                          </UlElements>
                        )}
                        <UlElements>
                          <li
                            className={`font-weight-bold ${
                              !this.state.number && "text-danger"
                            }`}
                          >
                            Number
                          </li>
                          <li className="li-font">{this.state.number}</li>
                        </UlElements>

                        <UlElements>
                          <li
                            className={`font-weight-bold ${
                              !this.state.invoice_number && "text-danger"
                            }`}
                          >
                            Purchase document number
                          </li>
                          <li className="li-font">
                            {this.state.invoice_number}
                          </li>
                        </UlElements>
                        <UlElements>
                          <li className="font-weight-bold">Type</li>
                          <li className="li-font">
                            {this.state.document_plan.document_type.name}
                          </li>
                        </UlElements>
                        <UlElements>
                          <li className="font-weight-bold">Plan</li>
                          <li className="li-font">
                            {this.state.document_plan.name}
                          </li>
                        </UlElements>
                        <UlElements>
                          <li
                            className={`font-weight-bold ${
                              !this.state.customer && "text-danger"
                            }`}
                          >
                            Client
                          </li>
                          <li className="li-font">{this.state.customer}</li>
                        </UlElements>
                        <UlElements>
                          <li
                            className={`font-weight-bold ${
                              !this.state.phone && "text-danger"
                            }`}
                          >
                            Phone number
                          </li>
                          <li className="li-font">{this.state.phone}</li>
                        </UlElements>
                        <UlElements>
                          <li
                            className={`font-weight-bold ${
                              !this.state.email && "text-danger"
                            }`}
                          >
                            E.mail
                          </li>
                          <li className="li-font">{this.state.email}</li>
                        </UlElements>
                      </div>
                      <div
                        className="col-6 my-3"
                        style={{ borderLeft: "1px solid #e3e3e3" }}
                      >
                        {this.state.contract_items.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              {item.order_row && (
                                <UlElements>
                                  <li className="font-weight-bold">Goods</li>
                                  <li className="li-font">
                                    {item.order_row.product_name}
                                  </li>
                                </UlElements>
                              )}
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.product_price && "text-danger"
                                  }`}
                                >
                                  Price of the item
                                </li>
                                <li className="li-font">
                                  {item.product_price}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.category && "text-danger"
                                  }`}
                                >
                                  Category
                                </li>
                                <li className="li-font">{item.category}</li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.model && "text-danger"
                                  }`}
                                >
                                  Model
                                </li>
                                <li className="li-font">{item.model}</li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.manufacturer && "text-danger"
                                  }`}
                                >
                                  Manufacturer
                                </li>
                                <li className="li-font">{item.manufacturer}</li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.id_number && "text-danger"
                                  }`}
                                >
                                  Serial number
                                </li>
                                <li className="li-font">{item.id_number}</li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !this.state.warranty && "text-danger"
                                  }`}
                                >
                                  Warranty
                                </li>
                                <li className="li-font">
                                  {this.warrantlyOption(this.state.warranty)}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !this.state.price && "text-danger"
                                  }`}
                                >
                                  Contract administration fee
                                </li>
                                <li className="li-font">
                                  {this.state.price} {"\u20AC"}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.item_price && "text-danger"
                                  }`}
                                >
                                  Plan price
                                </li>
                                <li className="li-font">
                                  {item.item_price} {"\u20AC"}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !item.item_discount && "text-danger"
                                  }`}
                                >
                                  Discount
                                </li>
                                <li className="li-font">
                                  {item.item_discount} {"\u20AC"}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !this.state.start_date && "text-danger"
                                  }`}
                                >
                                  Start date
                                </li>
                                <li className="li-font">
                                  {this.state.start_date}
                                </li>
                              </UlElements>
                              <UlElements>
                                <li
                                  className={`font-weight-bold ${
                                    !this.state.end_date && "text-danger"
                                  }`}
                                >
                                  End date
                                </li>
                                <li className="li-font">
                                  {this.state.end_date}
                                </li>
                              </UlElements>

                              <UlElements>
                                {item.additional_data.length > 0 && (
                                  <li>
                                    <div className="fontBold">
                                      Additional information
                                    </div>
                                    <div className="border p-2">
                                      {item.additional_data.map(
                                        (additional, index) => {
                                          return (
                                            <div key={index} className="mb-1">
                                              <div className="fontBold">
                                                {this.additionalOption(
                                                  additional.key
                                                )}
                                              </div>
                                              <div className="liText">
                                                {additional.text}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </li>
                                )}
                              </UlElements>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="col-12 mb-3">
                        <div className="d-flex justify-content-center">
                          <LongButton
                            style={{ marginRight: "5px" }}
                            text={`The final amount: ${
                              +this.state.total || 0
                            } ${"\u20AC"}`}
                          />
                          <Button1
                            style={{ marginLeft: "5px" }}
                            option={"upload"}
                            text={"Download"}
                            onClick={() => this.downloadDocument()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {/* {this.blocksRender(1)} */}
          </div>
          <div className="col">{this.blocksRender(2)}</div>
        </div>
      </BasicModalOrder>
    );
  }
}

export default ListOfDocumentsModal;

// const MainBlock = styled.div`
//   background-color: #f2f2f2;
//   padding: 8px 10px;
//   display: block;
//   font-weight: 700;
//   color: #000000;
//   font-size: 12px;
// `;

const UlElements = styled.ul`
  margin-bottom: 8px;
  list-style-type: none;
  padding: 0px;
  li {
    word-wrap: break-word;
    font-size: 10px;
    line-height: 14px;
    color: #000000;
  }
  .li-font {
    font-size: 14px;
  }
`;
const EmailBlock = styled.div`
  border-radius: 3px;
  padding: 10px 10px;
  margin-bottom: 5px;
  background-color: rgb(251, 251, 251);
  .receiver {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;
